import { apiClient } from './apiClient';

export interface PopupBanner {
  id: number;
  image_url: string;
  link_url: string | null;
  sort_order: number;
}

/** 활성 팝업 목록 조회 (로그인 사용자용, sortOrder 순) */
export const getActivePopups = async (): Promise<PopupBanner[]> => {
  const response = await apiClient.get('/api/ui/popup');
  const data = response.data?.data;
  return Array.isArray(data) ? data : [];
};

/** 관리자: 팝업 배너 신규 등록 */
export const createPopupBanner = async (
  imageFile: File,
  linkUrl: string,
): Promise<PopupBanner> => {
  const formData = new FormData();
  formData.append('imageFile', imageFile);
  formData.append('linkUrl', linkUrl);
  const response = await apiClient.post('/api/admin/popup', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

/** 관리자: 팝업 배너 수정 (imageFile 없으면 기존 이미지 유지) */
export const updatePopupBanner = async (
  id: number,
  imageFile: File | null,
  linkUrl: string,
): Promise<PopupBanner> => {
  const formData = new FormData();
  if (imageFile) formData.append('imageFile', imageFile);
  formData.append('linkUrl', linkUrl);
  const response = await apiClient.put(`/api/admin/popup/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

/** 관리자: 팝업 배너 삭제 */
export const deletePopupBanner = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/admin/popup/${id}`);
};
